// extracted by mini-css-extract-plugin
module.exports = {"tourTitle":"Contact_tourTitle__SfRcN","tourBody":"Contact_tourBody__2729S"};